/*
 * @Descripttion: your project
 * @version: 1.0
 * @Author: CZK
 * @Date: 2025-06-09 16:10:34
 * @LastEditors: CZK
 * @LastEditTime: 2026-07-01 18:21:48
 */
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import Vue from 'vue'
import App from './App.vue'

// 全局样式
import '@/assets/css/vendors.css'
import '@/assets/css/app.css'
import '@/assets/css/animate.css'

import router from './router'
// import store from './store'
Vue.config.productionTip = false
import faIn from './utils/faIn'

// import VueLazyLoad from 'vue-lazyload';
// Vue.use(VueLazyLoad, {
//   preLoad: 1.3,          // 预加载高度比例（默认 1.3）
//   loading: require('@/assets/loading.gif'), // 加载中占位图
//   error: require('@/assets/error.gif'),     // 加载失败占位图
//   attempt: 3,            // 加载失败重试次数（默认 3）
//   listenEvents: ['scroll'] // 监听的事件（默认包含 scroll、resize 等）
// });

new Vue({
  router,
  // store,
  render: h => h(App)
}).$mount('#app')
